export const GRID_SPACING = '10px';
export const MOBILE_DATA_GRID_COLUMN = 'mobile-data-grid-column';

/**
 * Standard height (px) for compact form controls — filter inputs, dropdowns, and the
 * buttons beside them — so a row of mixed control types lines up. Single source of truth
 * for the visual-polish standardisation; change here to adjust everywhere it's applied.
 */
export const STANDARD_FIELD_HEIGHT = 26;

/**
 * Body padding for panels that host editable rows (the Part Type warranty,
 * attribute, pricing and bill-of-materials panels).
 *
 * Those row molecules place the toggle caption above the switch and pull the
 * group up 15px so the switch aligns with the text fields beside it. Panel clips
 * its body, so the body needs more top room than that pull.
 */
export const ROW_PANEL_BODY_PADDING = '20px 14px 12px';

/**
 * A form grid whose column count follows the *container*, not the viewport.
 *
 * Address and contact forms appear both across a full page and inside a
 * half-width panel. Viewport breakpoints can't tell those apart, so `md: 4`
 * gave the panel three ~150px columns and truncated every label — "Contact
 * Company" as "Contact Com…", "Victoria" as "Vic…". Apply this to the grid and
 * set `containerType: 'inline-size'` on its wrapper.
 */
export const RESPONSIVE_FIELD_GRID_SX = {
  display: 'grid',
  gap: 2,
  gridTemplateColumns: '1fr',
  '@container (min-width: 420px)': { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' },
  '@container (min-width: 760px)': { gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' },
};
